import { PropsWithChildren } from 'react';

import { cn } from '@/utils/styles';

import LoadingCircle from '../loading/LoadingCircle';

function StakeButton({
  loading,
  disabled,
  onClick,
  children,
  className,
}: {
  loading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
} & PropsWithChildren) {
  return (
    <div className="flex items-center justify-center">
      <button
        className={cn(
          'flex justify-center items-center duration-300 rounded-full text-base font-semibold',
          'w-[180px] h-[44px] md:w-[260px] md:h-[56px]',
          disabled || loading
            ? 'bg-[#1F242F] text-[#85888E] cursor-not-allowed'
            : 'text-white bg-[#4565E5] hover:bg-[#2A49C7]',
          className,
        )}
        disabled={disabled}
        onClick={onClick}
      >
        {loading ? <LoadingCircle /> : children}
      </button>
    </div>
  );
}
export default StakeButton;
